import { Fragment, useCallback, useState } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Icons, IconsTitle } from "../../../Constants/Constants";
import { FontAwesomeData } from "../../../Data/Icons/FontAwesomeIcon";
import IconMarkUp from "../Common/IconMarkUp";
import { FontAwesomeBody } from "./FontAwesomeBody";

export const FontAwesomeIconContainer = () => {
  const [iconTag, setIconTag] = useState({ iconTag: "" });
  const [icon, setIcon] = useState({ icon: "" });
  const [iconFClass, setIconFClass] = useState({ iconFClass: "" });
  const callback = useCallback((tag: string) => {
    setIconTag({
      iconTag: '<i className="fa fa-' + tag + '"></i>',
    });
    setIcon({
      icon: "fa fa-" + tag + " fa-2x",
    });
    setIconFClass({
      iconFClass: "fa fa-" + tag,
    });
  }, []);
  return (
    <Fragment>
      <Breadcrumbs mainTitle={IconsTitle} parent={Icons} />
      <Container fluid>
        <Row>
          {FontAwesomeData.map((data, i) => (
            <FontAwesomeBody key={i} iconType={data.data} title={data.title} parentCallback={callback} />
          ))}
        </Row>
      </Container>
      <IconMarkUp iconTag={iconTag} icon={icon} iconFClass={iconFClass} />
    </Fragment>
  );
};
